import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import MapViewerReact from "../MapViewerReact";
import SearchMapBox from "../GeocodingSearchBox";
import { setFlyLocation } from "../../store/mapStateSlice";

interface ChatMapDrawerProps {
  // Reports the currently drawn geometry (or null when cleared) up to the modal, which owns the Cancel/Confirm footer and the KML conversion.
  onGeojsonChange: (geojson: any | null) => void;
  className?: string;
}

/** The draw-on-map body (instructions + map + geocode search), with no modal chrome and no action buttons — ChatMapDrawerModal supplies those via the ModalBase footer so they stay pinned while the map scrolls. */
const ChatMapDrawer: React.FC<ChatMapDrawerProps> = ({ onGeojsonChange, className }) => {
  const dispatch = useDispatch();

  const handleGeoCodeSelect = useCallback((lngLat: number[]) => {
    dispatch(setFlyLocation([
      parseFloat(lngLat[0].toFixed(5)),
      parseFloat(lngLat[1].toFixed(5)),
    ]));
  }, [dispatch]);

  const handleGeojsonUpdate = useCallback(
    (data: any, _centroid: any, isInit?: boolean) => {
      if (isInit) return null;
      onGeojsonChange(data?.features?.length > 0 ? data : null);
    },
    [onGeojsonChange]
  );

  return (
    <div className={`flex flex-col h-full min-h-0 ${className ?? ""}`}>
      <p className="eai-description-sm mb-3 shrink-0">
        Select a draw mode, then click on the map to place points. For a
        rectangle, click two opposite corners. Click &quot;Reset&quot; to start
        over.
      </p>
      {/* Cast needed: MapViewerReact uses @ts-nocheck + forwardRef with no typed props */}
      {React.createElement(MapViewerReact as any, {
        defaultLat: 47,
        defaultLng: -95,
        defaultZoom: 3,
        onGeojsonUpdate: handleGeojsonUpdate,
        OnClick: () => {},
        fillHeight: true,
        children: <SearchMapBox onSelected={handleGeoCodeSelect} />,
      })}
    </div>
  );
};

export default ChatMapDrawer;
